import CurrencyUtility from '../../../common/utility/CurrencyUtility';
import KaraokeOrderPriceInfo from './KaraokeOrderPriceInfo';

type KaraokeOrderFormView3InvoiceViewFieldName =
  'royalty_order'|'onvocal'|'physical'|'duet'|'intro_click'|'payment_method'|'coupon_code'|'use_balance';

export default function KaraokeOrderFormView3InvoiceView({
  getValue,
  paymentAmount,
  billingAmount,
  discountAmount,
  hasNonAppliedInitialOrderCoupon,
  priceInfo,
  style,
} : {
  getValue: (name: KaraokeOrderFormView3InvoiceViewFieldName) => string,
  paymentAmount: number,
  billingAmount: number,
  discountAmount: number,
  hasNonAppliedInitialOrderCoupon: boolean,
  priceInfo: KaraokeOrderPriceInfo,
  style?: {},
}) {
  const options = [];
  if (getValue('royalty_order') === 'with_royalty') {
    options.push(`印税あり +${CurrencyUtility.format(priceInfo.royaltyOptionAmount)}円`);
  }
  if (getValue('onvocal') === '1') {
    options.push(`本人歌唱 +${CurrencyUtility.format(priceInfo.onvocalOptionAmount)}円`);
  }
  if (getValue('physical') === '1') {
    options.push(`郵送 +${CurrencyUtility.format(priceInfo.physicalOptionAmount)}円`);
  }
  if (getValue('duet') === '1') {
    options.push(`デュエット +${CurrencyUtility.format(priceInfo.duetOptionAmount)}円`);
  }
  if (getValue('intro_click') === '1') {
    options.push(`冒頭カウント +${CurrencyUtility.format(priceInfo.introClickOptionAmount)}円`);
  }

  const salesAmount = billingAmount;
  const redemptionAmount = CurrencyUtility.format(billingAmount - paymentAmount);

  return (
    <table className="prices_table" style={style}>
      <tbody>
        <tr>
          <th>配信手数料</th>
          <td>{`${CurrencyUtility.format(priceInfo.basicAmount)}円`}</td>
        </tr>
        {options.map((value, index) => (
          <tr key={value}>
            <th>{index === 0 ? 'オプション' : ''}</th>
            <td>{value}</td>
          </tr>
        ))}
        {getValue('coupon_code') !== '' && (
          <tr>
            <th>クーポンコード</th>
            {hasNonAppliedInitialOrderCoupon && (
              <td>{`${getValue('coupon_code')}（初回限定クーポンのため適用されませんでした） 0円`}</td>
            )}
            {!hasNonAppliedInitialOrderCoupon && (
              <td>{`${getValue('coupon_code')} -${discountAmount}円`}</td>
            )}
          </tr>
        )}
        {getValue('payment_method') !== '' && (
          <tr>
            <th>お支払い方法</th>
            <td>
              {getValue('payment_method') === 'cc_payment' && (
              <span>クレジットカード</span>
              )}
              {getValue('payment_method') === 'bank_transfer' && (
              <span>銀行振込</span>
              )}
            </td>
          </tr>
        )}
        <tr>
          <th>小計</th>
          <td>
            <b>{CurrencyUtility.format(salesAmount)}</b>
            円（税込）
            <br />
            <span className="small">{`消費税（10％）${CurrencyUtility.format(Math.floor(salesAmount * 10 / 110))}円`}</span>
          </td>
        </tr>
        {getValue('use_balance') === '1' && redemptionAmount !== '0' && (
          <tr>
            <th>Frekul残高使用</th>
            <td>{`-${redemptionAmount}円`}</td>
          </tr>
        )}
        <tr>
          <th><b>お支払額</b></th>
          <td>
            <b>{CurrencyUtility.format(paymentAmount)}</b>
            円
          </td>
        </tr>        
      </tbody>
    </table>
  );
}

